import { render, staticRenderFns } from "./listings.vue?vue&type=template&id=3b4f8156"
import script from "./listings.vue?vue&type=script&lang=js"
export * from "./listings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports